import { Brand, RemoteData, remoteDataNotFetched } from '@common/util-models';

export interface BrandsState {
  brands: Brand[];
  remoteState: RemoteData<null>;
}

export interface BrandsByApplianceState {
  [key: string]: BrandsState;
}

export const initialBrandState: BrandsState = {
  brands: [],
  remoteState: remoteDataNotFetched(),
};
